import axios from "axios";

export default function saveCurrentProgress({ signal }) {
  const source = axios.CancelToken.source();

  if (signal) {
    signal.addEventListener("abort", () => {
      source.cancel();
    });
  }

  return ({
    value,
    selectedProduct,
    id,
    locale,
    userChoiceValuesForUI,
    final_image,
    cost,
  }) => {
    const url = window.location.href;

    return axios({
      url: process.env.REACT_APP_SHARE_RECIPE_URL,
      method: "POST",
      cancelToken: source.token,
      headers: {
        Accept: "text/html",
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data: new URLSearchParams({
        data: JSON.stringify({
          token: process.env.REACT_APP_KLAVIYO_PUBLIC_KEY,
          event: "Abandoned MyBauer",
          customer_properties: {
            $email: value,
          },
          properties: {
            value: cost,
            message: url,
            finalImage: final_image,
            userChoices: userChoiceValuesForUI,
            selectedProductName: selectedProduct.name,
            productId: id,
            locale,
          },
        }),
      }),
    });
  };
}
